import React from "react";
import { ButtonComponent, Type } from "./Button"; // Assuming ButtonComponent accepts a loading prop
// --- Removed CSS import ---
// import './ChoiceButtons.css';
import { localise } from "../../../locale/locale"; // Adjust path as needed
// --- Import AnimatedGrid ---
import { AnimatedGrid } from "../../MotionMui/MotionMui"; // Adjust path as needed

export interface ChoiceButtonsProps {
    primaryButtonText: string;
    primaryButtonAction(): void;
    primaryButtonDisabled?: boolean;
    primaryButtonWrapper?(button: any): any;
    secondaryButtonText: string;
    secondaryButtonAction(): void;
    secondaryButtonDisabled?: boolean;
    loading?: boolean;
}

const noWrapper = (button: any): any => button;

export const ChoiceButtonsComponent = (props: ChoiceButtonsProps) => {

    const primaryButtonWrapper = props.primaryButtonWrapper ?? noWrapper;
    const isLoading = props.loading ?? false; // Default loading to false

    return (
        // --- Replace div with AnimatedGrid container ---
        <AnimatedGrid
            container
            spacing={2} // Adds space between buttons, adjust as needed
            root // Apply initial animation to the container
            staggerSpeed='VeryFast' // Stagger animation for child items (buttons)
            sx={{ width: '100%' }} // Ensure it takes full width if needed
        >
            {/* --- Wrap Secondary Button in AnimatedGrid item --- */}
            <AnimatedGrid item xs={6} sx={{ textAlign: 'center' }}> {/* Center button within grid item */}
                 <ButtonComponent
                    type={Type.SECONDARY}
                    onClick={props.secondaryButtonAction}
                    disabled={isLoading || (props.secondaryButtonDisabled ?? false)}
                    loading={isLoading && !props.secondaryButtonDisabled}
                 >
                    {localise(props.secondaryButtonText)}
                 </ButtonComponent>
            </AnimatedGrid>

             {/* --- Wrap Primary Button in AnimatedGrid item --- */}
            <AnimatedGrid item xs={6} sx={{ textAlign: 'center' }}> {/* Center button within grid item */}
                 {primaryButtonWrapper(
                    <ButtonComponent
                        type={Type.PRIMARY}
                        onClick={props.primaryButtonAction}
                        disabled={isLoading || (props.primaryButtonDisabled ?? false)}
                        loading={isLoading && !props.primaryButtonDisabled}
                    >
                        {localise(props.primaryButtonText)}
                    </ButtonComponent>
                 )}
            </AnimatedGrid>
        </AnimatedGrid>
    );
}